import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  sales_return_details: [],
};

const getters = {
  allSalesReturnDetails: (state) => state.sales_return_details,
};

const actions = {
  async fetchSalesReturnDetails({ commit }, params = {}) {
    try {
      commit("resetSalesReturnDetails");
      const response = await axios.get("/sales-return-detail", { params: prm(params) });
      commit("setSalesReturnDetails", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch sales_return_details:", error);
    }
  },
  async createSalesReturnDetail({ commit }, sales_return_detail) {
    try {
      const response = await axios.post("/sales-return-detail", sales_return_detail);
      commit("addSalesReturnDetail", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create sales_return_detail:", error);
      throw error;
    }
  },
  async fetchSalesReturnDetailById(_, id) {
    try {
      const response = await axios.get(`/sales-return-detail/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch sales_return_detail:", error);
      throw error;
    }
  },
  async updateSalesReturnDetail({ commit }, sales_return_detail) {
    try {
      const response = await axios.put(`/sales-return-detail/${sales_return_detail.id}`, sales_return_detail);
      commit("updateSalesReturnDetail", response.data);
    } catch (error) {
      console.error("Failed to update sales_return_detail:", error);
      throw error;
    }
  },
  async deleteSalesReturnDetailById({ commit }, id) {
    try {
      const response = await axios.delete(`/sales-return-detail/${id}`);
      commit("removeSalesReturnDetail", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete sales_return_detail:", error);
      throw error;
    }
  },
};

const mutations = {
  setSalesReturnDetails(state, sales_return_details) {
    state.sales_return_details = sales_return_details.data; // Ensure this matches your API's response structure
  },
  addSalesReturnDetail(state, sales_return_detail) {
    state.sales_return_details.push(sales_return_detail);
  },
  updateSalesReturnDetail(state, updatedSalesReturnDetail) {
    const index = state.sales_return_details.findIndex(
      (sales_return_detail) => sales_return_detail.id === updatedSalesReturnDetail.id
    );
    if (index !== -1) {
      state.sales_return_details.splice(index, 1, updatedSalesReturnDetail);
    }
  },
  removeSalesReturnDetail(state, id) {
    state.sales_return_details = state.sales_return_details.filter(
      (sales_return_detail) => sales_return_detail.id !== id
    );
  },
  resetSalesReturnDetails(state) {
    state.sales_return_details = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
